import React from 'react';

function Extensions() {
  return (
    <div>
      <h1>Extensions Page!</h1>
    </div>
  );
}

export default Extensions;
